import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import Loader from "../../shared/loader";

const SampleBrackage = () => {
  const [samplebrackage, setSampleBrackage] = useState([]);
  const [loading, setLoading] = useState(true);

  const getCreditnotes = () => {
    axios.post(API_URL.SAMPLES_LIST, {}).then(
      (res) => {
        if (res.data.status === 1) {
          res.data.data.data.map(item => item.date = moment(item.date).format('DD/MM/YYYY'));
          setSampleBrackage(res.data.data.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,

        });
      }
    );
  };

  const deleteParty = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Invoice No - " + row.party.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.SAMPLES_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = samplebrackage.filter((r) => r.id != row.id);
              setSampleBrackage(newData);
            toast.success("Delete Successfully", { autoClose: 3000 });
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  useEffect(() => {
    getCreditnotes();
  }, []);
  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>
            Sample & Brackage <small className="me-2">({samplebrackage.length})</small>
          </h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/sales/sample-brackage/add"} className="btn btn-primary">
              <i className="fa fa-plus-circle me-2" aria-hidden="true"></i>
              Add Sample & Brackage
            </Link>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body p-0">
              {loading && <Loader></Loader>}
              {!loading && (
                <div className="table-responsive">
                  <table className="table">
                    <thead className="">
                      <tr>
                        <th>#</th>
                        <th>Party Name</th>
                        <th>Date.</th>
                        <th>qty.</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {samplebrackage.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td>{key + 1}</td>
                            <td>
                              {row.party.name}
                            </td>
                            <td>
                              {row.date}
                            </td>
                            <td>
                               {row.qty}
                            </td>
                            <td>
                              <Link
                                to={"/sales/sample-brackage/edit/" + row.id}
                                className="btn btn-sm btn-secondary mr-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </Link>
                              <button
                                onClick={() => deleteParty(row)}
                                className="btn btn-sm btn-danger"
                              >
                                <i className="fa fa-trash me-1"></i> Delete
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SampleBrackage;
